import * as pdfjsLib from 'pdfjs-dist'

// Worker file is auto-copied to public/pdf.worker.min.mjs by the postinstall script.
// /memory-books is the app's base path on familysearch.org; the proxy strips it before
// forwarding to the Heroku server, which serves the file from public/.
// In dev, setupProxy.js intercepts this path before Snow's historyApiFallback handles it.
pdfjsLib.GlobalWorkerOptions.workerSrc = '/memory-books/pdf.worker.min.mjs'
